module.exports = __webpack_public_path__ + "static/img/plastic_256.e1b8551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plastic_256.png
// module id = MRkQ
// module chunks = 0